import React, { useReducer } from "react";
import { css } from "aphrodite";
import moment from "moment";
import { snakeCase } from "lodash";
import { style } from "./style";
import PulseLoader from "react-spinners/PulseLoader";
import { Col, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import "./card.css";
import { Link } from "react-router-dom";
import store from "../../../reducers/store";
export default function CategoriesCard({
  setActiveInactive,
  item,
  active,
  cardIndex,
  loading,
  tooltip
}) {
  let subCountArr = [];
  let OverlayTriggerProps = {
    placement: "top"
  }
  if (!item?.tooltip?.length) {
    OverlayTriggerProps = { ...OverlayTriggerProps, overlay: <Tooltip id="button-tooltip-2">{item.tooltip}</Tooltip> }
  }
  Object.keys(item?.counts).forEach((key, index) => {
    key !== "total" &&
      key !== "medAdherence" &&
      key !== "abnormalMotionInProgress" &&
      key !== "refillsDue" &&
      key !== "heartRateMonitoringEvents" &&

      subCountArr.push(
        <span>
          <label
            style={{
              color: item.countColorCodes[key],
            }}
          >{`${item.counts[key]}  ${snakeCase(key).replace(
            new RegExp("_", "g"),
            " "
          )}`}</label>
          <br />
        </span>
      );
  });
  const override = (React.CSSProperties = {
    display: "block",
    margin: "3em",
  });
  const handleClick = (item) => {
    store.dispatch({ type: "SET_AM_EVENT_DATA", payload: { abnormalMotionEvent: item } });
    store.dispatch({ type: "SET_UNPLANNED_MEDICAL_VISIT_EVENT_DATA", payload: { unplannedMedicalVisit: item } });
    store.dispatch({ type: "SET_CURRENT_MEDICATIONS_DATA", payload: { currentMedications: item } });
    store.dispatch({ type: "SET_MEDICATION_ADHERENCE_DATA", payload: { medicationAdherence: item } });
    store.dispatch({ type: "SET_SYMPTOMS_DATA", payload: { symptoms: item } });
    store.dispatch({ type: "SET_HRM_DATA", payload: { hrm: item } });
    store.dispatch({ type: "SET_HELP_DATA", payload: { help: item } });
    store.dispatch({ type: "SET_FALL_DATA", payload: { fallEvent: item } });
  }
  if (item.counts.planName !== null)
    return (
      <Col
        xs={12}
        sm={6}
        md={4}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "stretch",
          marginBottom: "20px",
          padding: "0px 5px 0px 5px"
          //fontFamily: "'Roboto', sans-serif"
        }}


      >
        {item.key !== "patientSubscriptionDetails" ?
          <OverlayTrigger
            placement="top"
            overlay={!!item.tooltip?.length ? <Tooltip id="button-tooltip-2">{item.tooltip}</Tooltip> : <></>}
          >

            <div class="p-3 category_box ">
              <Link
                to={`${item.link}`}
                //className={css(styles.tooltip)}
                style={{ textDecoration: "none" }}
                state={item ? item : ''}
                onClick={() => { handleClick(item) }}
                className={item?.link === '' ? 'no-link' : ''}
              >
                <div class="row">
                  <div
                    className="col-7"
                  //className={css(style.boxLeft)}
                  >
                    <h1>{item.label}</h1>

                    <h3>
                      {item.key !== "medicationAdherence"
                        ? item.counts.total !== undefined
                          ? item.counts.total
                          : 0
                        : `${item.counts.medAdherence} %`}
                    </h3>

                    {item.subLabel ? <h4>{item.subLabel}</h4> : null}
                  </div>

                  <div
                    className="col-5 right_block"
                  //className={css(style.boxRight)}
                  >
                    {loading ? (
                      <PulseLoader
                        cssOverride={override}
                        //size={50}
                        color={"#70757a"}
                        loading={loading}
                        //speedMultiplier={1.5}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <span>
                        {' '}
                        <div className="bottom_block">
                          {subCountArr}
                        </div>
                        <img src={item.image} />
                      </span>
                    )}
                  </div>
                </div>
                {/* <div className={css(style.name)}>
        <div>{item.type}</div>
      </div> */}

              </Link>

            </div>

          </OverlayTrigger>
          :
          <div class="p-3 category_box ">
            {/* <div class="row">
            <div
              className="col-lg-7"
            //className={css(style.boxLeft)}
            >
              <h1>{item.label}</h1>
              <h2>{"Current Plan"}</h2>
              <h6>{item.counts.planName}</h6>
            </div>

            <div
              className="col-lg-5 right_block"
              style={{ height: "150px" }}
            //className={css(style.boxRight)}
            >
              {loading ? (
                <PulseLoader
                  cssOverride={override}
                  //size={50}
                  color={"#70757a"}
                  loading={loading}
                  //speedMultiplier={1.5}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              ) :
                (<span>
                  {" "}
                  <div className="top_block">
                    <label className={item?.counts?.status === 1 ? "green" : item?.counts?.status === 4 ? "red" : "blue"}>
                      {item?.counts?.status === 1 ? "ACTIVE" : item?.counts?.status === 2 ? "TRIALING" : item?.counts?.status === 3 ? "PAYMENT PAST DUE" : "CANCELED"}
                    </label>
                  </div>
                  <div className="bottom_block">
                    <div>
                      <label>{"Start Date"}</label>
                      <br />
                      <label>
                        {item?.counts?.startDate !== null
                          ? moment(item?.counts?.startDate).format("MM/DD/YYYY")
                          : "--"}
                      </label>
                    </div>
                    {item?.counts?.status === 4 &&
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          item?.counts?.isOther ? <Tooltip id="button-tooltip-2">{`Cancellation Reason : ${item?.counts?.otherCancellationReason}`}</Tooltip> : <Tooltip id="button-tooltip-2"> {`Cancellation Reason : ${item?.counts?.subscriptionCancellationReason?.cancellationReason}`}</Tooltip>
                        }
                      >
                        <div>
                          <label>{"Cancellation Date"}</label>
                          <br />
                          <label>
                            {moment(item?.counts?.canceledAt).format("MM/DD/YYYY")}
                          </label>
                        </div>
                      </OverlayTrigger>
                    }
                  </div>
                  <img src={item.image} />
                </span>)
              }
            </div>
          </div> */}
            {/* <div className={css(style.name)}>
    <div>{item.type}</div>
  </div> */}

          </div>}

      </Col>
    );
}
